import agentsDiagram from '../../../img/renaissance-new/AIWorkshopDemo/1.webp';
import diffusionArt from '../../../img/renaissance-new/AIWorkshopDemo/2.webp';
import routingDiagram from '../../../img/renaissance-new/AIWorkshopDemo/3.webp';
import voiceApp from '../../../img/renaissance-new/AIWorkshopDemo/4.webp';
import dashboard from '../../../img/renaissance-new/AIWorkshopDemo/5.webp';

import agentsDiagramMobile from '../../../img/renaissance-new/AIWorkshopDemo/001.webp';
import diffusionArtMobile from '../../../img/renaissance-new/AIWorkshopDemo/002.webp';
import routingDiagramMobile from '../../../img/renaissance-new/AIWorkshopDemo/003.webp';
import voiceAppMobile from '../../../img/renaissance-new/AIWorkshopDemo/004.webp';
import dashboardMobile from '../../../img/renaissance-new/AIWorkshopDemo/005.webp';

export const AI_WORKSHOP_ROW_1 = [
  { illustration: agentsDiagram, mobileIllustration: agentsDiagramMobile },
  { illustration: diffusionArt, mobileIllustration: diffusionArtMobile },
];

export const AI_WORKSHOP_ROW_2 = [
  { illustration: routingDiagram, mobileIllustration: routingDiagramMobile },
  { illustration: voiceApp, mobileIllustration: voiceAppMobile },
  { illustration: dashboard, mobileIllustration: dashboardMobile },
];
